import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadCities: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.CITIES_ACTIONS.REQUESTED),
    switchMap(({ payload: { regionId } }) => {
      return regionApi.getCitiesByRegion(regionId).pipe(
        switchMap(({ cities, region }) =>
          of(actions.citiesSucceeded(cities, region)),
        ),
        catchError(error => of(actions.citiesFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Cities/services/epics/loadCities.ts